import React from "react";
import './Footer.css'

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <div className="contain">
          <div className="col">
            <h1>Company</h1>
            <ul>
              <li>About</li>
              <li>Mission</li>
              <li>Services</li>
              <li>Social</li>
              <li>Get in touch</li>
            </ul>
          </div>
          <div className="col">
            <h1>Products</h1>
            <ul>
              <li>About</li>
              <li>Mission</li>
              <li>Services</li>
              <li>Social</li>
              <li>Get in touch</li>
            </ul>
          </div>
          <div className="col">
            <h1>Accounts</h1>
            <ul>
              <li>About</li>
              <li>Mission</li>
              <li>Services</li>
              <li>Social</li>
              <li>Get in touch</li>
            </ul>
          </div>
          <div className="col">
            <h1>Resources</h1>
            <ul>
              <li>Webmail</li>
              <li>Redeem code</li>
              <li>WHOIS lookup</li>
              <li>Site map</li>
              <li>Web templates</li>
              <li>Email templates</li>
            </ul>
          </div>
          <div className="col">
            <h1>Support</h1>
            <ul>
              <li>Contact us</li>
              <li>Web chat</li>
              <li>Open ticket</li>
            </ul>
          </div>
          <div className="col social align-items-start">
            <h1>Social</h1>
            <ul>
              <li>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons.flaticon.com/png/512/720/premium/720255.png?token=exp=1643175413~hmac=2307f66be589f7fd04dfcddcbe69ef19"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons.flaticon.com/png/512/3256/premium/3256013.png?token=exp=1643175450~hmac=59d4c984f4a2393e3c523ea4d6617ff8"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons.flaticon.com/png/512/720/premium/720255.png?token=exp=1643175413~hmac=2307f66be589f7fd04dfcddcbe69ef19"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons.flaticon.com/png/512/3256/premium/3256013.png?token=exp=1643175450~hmac=59d4c984f4a2393e3c523ea4d6617ff8"
                  style={{ width: "32px" }}
                />
              </li>
              <li>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                  style={{ width: "32px" }}
                />
              </li>
            </ul>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
